// One-time setup links (Nick, 2026-10-23: "the password is set at the first
// sign-in"): the account command creates an account without a password and
// issues a link; the person opens it and chooses the password. Lifetime and
// shape are the agent's proposal recorded in the add-public-homepage design.
const HOUR_MS = 3_600_000;
const DAY_MS = 24 * HOUR_MS;

/** A link works for 48 hours after it is issued, once. */
export const SETUP_LINK_TTL_MS = 48 * HOUR_MS;
/** Closed links (used, revoked, expired) stay this long for diagnosis. */
export const SETUP_LINK_RETENTION_MS = 30 * DAY_MS;

/** 256 random bits, base64url without padding. */
export const SETUP_TOKEN = /^[A-Za-z0-9_-]{43}$/;

export function setupLinkExpiresAt(issuedAt: Date): Date {
  return new Date(issuedAt.getTime() + SETUP_LINK_TTL_MS);
}

/** The fragment that carries the token: never sent to a server, a log or a Referer. */
export const SETUP_FRAGMENT_KEY = "token";
